/**
 * Client-side SHA-256 hash computation using the Web Crypto API.
 *
 * Computes the hash before any bytes leave the browser, enabling
 * dedup checks via the backend's initiate-upload endpoint.
 */

/**
 * Compute the SHA-256 hex digest of a File.
 *
 * @param file - File to hash.
 * @returns Lowercase hex string (64 characters).
 */
export async function computeSHA256(file: File): Promise<string> {
  const buffer = await file.arrayBuffer();
  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}
